import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import { Badge } from "@/components/ui/badge";
import type { PrivateHireExtra } from "@/lib/coach-manager/types";

/**
 * Movement-level chargeable extras — a category Contract's Movement doesn't
 * have. Same leaf-table shape as the other nested tables (`PickupsTable`,
 * etc.), just with a WSDL-native column set (quantity/pricing/VAT/nominal
 * code + a Revenue flag).
 */
export function PrivateHireExtrasTable({ extras }: { extras: PrivateHireExtra[] }) {
  if (extras.length === 0) return null;

  return (
    <DataTable
      headers={[
        { label: "Description" },
        { label: "Quantity" },
        { label: "Unit Price" },
        { label: "Price" },
        { label: "VAT Code" },
        { label: "VAT" },
        { label: "VAT %" },
        { label: "Total" },
        { label: "Nominal Code" },
        { label: "Revenue" },
      ]}
    >
      {extras.map((extra) => (
        <tr key={extra.PrivateHireExtraID} className="border-b last:border-b-0">
          <td className="px-4 py-2">{formatCellValue(extra.Description)}</td>
          <td className="px-4 py-2">{extra.Quantity}</td>
          <td className="px-4 py-2">{extra.UnitPrice}</td>
          <td className="px-4 py-2">{extra.Price}</td>
          <td className="px-4 py-2">{extra.VATCode}</td>
          <td className="px-4 py-2">{extra.VAT}</td>
          <td className="px-4 py-2">{extra.VATPercentage}</td>
          <td className="px-4 py-2">{extra.Total}</td>
          <td className="px-4 py-2">{formatCellValue(extra.NominalCode)}</td>
          <td className="px-4 py-2">
            {extra.Revenue && <Badge variant="secondary">Revenue</Badge>}
          </td>
        </tr>
      ))}
    </DataTable>
  );
}
